export default __webpack_public_path__ + "static/media/house_three.8c84e6f0.jpg";